const tab = "   ";
export default function Attribute(props) {
  return (
    <div className="Attribute">
      <span>{props.title}</span>
      <span>{props.description}</span>
    </div>
  );
}

const Education = (
  <div className="Education">
    <pre>
      <span className="Heading">UG</span> : 87.5%
      <br />
      {tab}College :Sangameshwar College,
      <br />
      {tab}Solapur
      <br />
      <span className="Heading">HSC </span>: 62 %<br />
      {tab}College :S.V.C.S. JR College,
      <br />
      {tab}Solapur
      <br />
      <span className="Heading">SSC</span> : 75.40 %<br />
      {tab}College :S.V.C.S. HighSchool,
      <br />
      {tab}Solapur
      <br />
    </pre>
  </div>
);

const Skills = (
  <div className="Skills">
    <span>Html , css </span>
    <span>Javascript , MERN Stack </span>
    <span>Java , Android </span>
    <span>Python , Django Rest Framework </span>
    <span>Flutter </span>
    <span>Robot Framework ( UI , API test ) </span>
    <span>Git , GitHub </span>
  </div>
);
const Experience = (
  <div className="Skills">
    <span>
      <b>Company</b> : Tata Consultancy Services
    </span>
    <span>
      <b>Duration : </b> October 2022 to present
    </span>
    <span>
      <b>Role</b> : Developer & Automation Tester
    </span>
    <span>
      <b>Technologies </b> : ReactJs , Python Robot <br /> Framework
    </span>
  </div>
);
const Projects = (
  <pre className="Projects">
    <a
      rel="noreferrer"
      target="_blank"
      href="https://gituservivek.github.io/devclone"
    >
      Dev.to Clone
    </a>
    <a
      rel="noreferrer"
      target="_blank"
      href="https://gituservivek.github.io/typingTest"
    >
      TypingTest
    </a>
    <a
      rel="noreferrer"
      target="_blank"
      href="https://gituservivek.github.io/jvs"
    >
      MyPortfolio
    </a>
    <a
      rel="noreferrer"
      target="_blank"
      href="https://gituservivek-7htfo7gxg-itzjvs.vercel.app/"
    >
      Git User Detailer
    </a>

    <span>Dev.to Clone ( Android )</span>
  </pre>
);

export { Education, Skills, Experience, Projects };
